import { render, staticRenderFns } from "./DatInstances.vue?vue&type=template&id=9a584d1e&scoped=true"
import script from "./DatInstances.vue?vue&type=script&lang=ts"
export * from "./DatInstances.vue?vue&type=script&lang=ts"
import style0 from "./DatInstances.vue?vue&type=style&index=0&id=9a584d1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a584d1e",
  null
  
)

export default component.exports